import * as stylex from '@stylexjs/stylex';

const pulse = stylex.keyframes({
    '0%, 100%': {
        transform: 'scale(1)', opacity: 1
    }

    ,
    '50%': {
        transform: 'scale(1.05)', opacity: 0.8
    }

    ,
});

const MOBILE = '@media (max-width: 768px)';
const SMALL_MOBILE = '@media (max-width: 480px)';

export const styles = stylex.create({
    supportPage: {
        maxWidth: 'var(--max-width)',
        marginInline: 'auto',
        paddingInline: 'var(--spacing-md)',
        color: 'var(--text-primary)',
        scrollBehavior: 'smooth',
    }

    ,
    backLink: {

        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        color: {
            default: 'var(--text-secondary)',
            ':hover': 'var(--primary)',
        }

        ,
        textDecoration: 'none',
        fontSize: 'var(--font-size-sm)',
        marginBottom: 'var(--spacing-md)',
        transitionProperty: 'color',
        transitionDuration: 'var(--transition-fast)',
    }

    ,
    heroSection: {

        backgroundImage: `linear-gradient(135deg,
            var(--bg-card) 0%,
            rgba(59, 130, 246, 0.02) 15%,
            rgba(16, 185, 129, 0.02) 35%,
            rgba(255, 107, 107, 0.02) 55%,
            var(--bg-card) 100%)`,
        borderRadius: 'var(--radius-xl)',
        padding: {
            default: 'var(--spacing-3xl)',
            [MOBILE]: 'var(--spacing-xl)',
            [SMALL_MOBILE]: 'var(--spacing-lg)',
        }

        ,
        marginBottom: 'var(--spacing-3xl)',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        backdropFilter: 'blur(4px)',
        '::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.03) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(16, 185, 129, 0.03) 0%, transparent 50%)`,
            opacity: 1,
        }

        ,
    }

    ,
    heroContent: {
        position: 'relative',
        zIndex: 2,
    }

    ,
    heroIcon: {
        marginBottom: 'var(--spacing-lg)',
        color: 'var(--accent)',
        animationName: pulse,
        animationDuration: '2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
    }

    ,
    heroTitle: {
        fontSize: {
            default: '2.5rem',
            [MOBILE]: '2rem',
            [SMALL_MOBILE]: '1.75rem',
        }

        ,
        fontWeight: 700,
        margin: '0 0 var(--spacing-lg) 0',
        color: 'var(--text-primary)',
        lineHeight: 1.2,
    }

    ,
    heroDescription: {
        fontSize: 'var(--font-size-lg)',
        color: 'var(--text-secondary)',
        lineHeight: 1.6,
        marginBottom: 'var(--spacing-2xl)',
        maxWidth: '600px',
        marginInline: 'auto',
    }

    ,
    heroStats: {

        display: 'flex',
        justifyContent: 'center',
        gap: 'var(--spacing-xl)',
        flexWrap: 'wrap',
        flexDirection: {
            [MOBILE]: 'column'
        }

        ,
    }

    ,
    stat: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        color: 'var(--text-secondary)',
        fontSize: 'var(--font-size-sm)',
        fontWeight: 500,
    }

    ,
    statIcon: {
        color: 'var(--accent)',
    }

    ,
    sectionHeader: {
        textAlign: 'center',
        marginBottom: 'var(--spacing-2xl)',
    }

    ,
    sectionHeaderIcon: {
        color: 'var(--accent)',
        marginBottom: 'var(--spacing-md)',
    }

    ,
    sectionHeaderH3: {
        fontSize: 'var(--font-size-2xl)',
        fontWeight: 600,
        margin: '0 0 var(--spacing-md) 0',
        color: 'var(--text-primary)',
    }

    ,
    sectionHeaderP: {
        fontSize: 'var(--font-size-lg)',
        color: 'var(--text-secondary)',
        margin: 0,
        maxWidth: '500px',
        marginInline: 'auto',
    }

    ,
    contactCard: {

        backgroundColor: 'var(--bg-surface)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'var(--border)',
        borderRadius: 'var(--radius-xl)',
        padding: {
            default: 'var(--spacing-2xl)',
            [MOBILE]: 'var(--spacing-lg)',
            [SMALL_MOBILE]: 'var(--spacing-md)',
        },
        marginBottom: 'var(--spacing-2xl)',


        maxWidth: '800px',
        marginInline: 'auto',
        backdropFilter: 'blur(4px)',
    }

    ,
    contactInfo: {
        textAlign: 'center',
        marginBottom: 'var(--spacing-2xl)',
    }

    ,
    contactInfoH4: {
        fontSize: 'var(--font-size-xl)',
        fontWeight: 600,
        margin: '0 0 var(--spacing-md) 0',
        color: 'var(--text-primary)',
    }

    ,
    emailAddress: {
        fontSize: 'var(--font-size-xl)',
        marginBottom: 'var(--spacing-md)',
    }

    ,
    emailLink: {
        color: {
            default: 'var(--accent)',
            ':hover': 'var(--accent-hover)',
        }

        ,
        textDecoration: 'none',
        fontWeight: 600,
        transitionProperty: 'color',
        transitionDuration: 'var(--transition-fast)',
    }

    ,
    responseTime: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--spacing-sm)',
        color: 'var(--text-secondary)',
        fontSize: 'var(--font-size-sm)',
    }

    ,
    emailGuidelinesH5: {
        fontSize: 'var(--font-size-lg)',
        fontWeight: 600,
        margin: '0 0 var(--spacing-md) 0',
        color: 'var(--text-primary)',
    }

    ,
    guidelinesList: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
    }

    ,
    guidelineItem: {

        paddingBlock: 'var(--spacing-sm)',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'var(--border)',
        color: 'var(--text-secondary)',
        lineHeight: 1.5,
        ':last-child': {
            borderBottomWidth: 0,
        }

        ,
    }

    ,
    helpCategories: {
        marginBottom: 'var(--spacing-3xl)',
    }

    ,
    helpCategoriesH3: {
        textAlign: 'center',
        fontSize: 'var(--font-size-2xl)',
        fontWeight: 600,
        margin: '0 0 var(--spacing-2xl) 0',
        color: 'var(--text-primary)',
    }

    ,
    categoriesGrid: {

        display: 'grid',
        gridTemplateColumns: {
            default: 'repeat(auto-fit, minmax(250px, 1fr))',
            [MOBILE]: '1fr',
        }

        ,
        gap: 'var(--spacing-lg)',
        maxWidth: '1000px',
        marginInline: 'auto',
    }

    ,
    categoryCard: {

        backgroundColor: 'var(--bg-surface)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: {
            default: 'var(--border)',
            ':hover': 'var(--accent)',
        }

        ,
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--spacing-xl)',
        textAlign: 'center',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-normal)',
        cursor: 'pointer',
        backdropFilter: 'blur(4px)',
        transform: {
            default: 'none',
            ':hover': 'translateY(-4px)',
        }

        ,
        boxShadow: {
            default: 'none',
            ':hover': 'var(--shadow-lg)',
        }

        ,
    }

    ,
    categoryIcon: {
        color: 'var(--accent)',
        marginBottom: 'var(--spacing-md)',
    }

    ,
    categoryH4: {
        fontSize: 'var(--font-size-lg)',
        fontWeight: 600,
        margin: '0 0 var(--spacing-md) 0',
        color: 'var(--text-primary)',
    }

    ,
    categoryP: {
        color: 'var(--text-secondary)',
        margin: 0,
        lineHeight: 1.5,
    }

    ,
    finalCta: {
        backgroundImage: `linear-gradient(135deg,
            var(--bg-card) 0%,
            rgba(59, 130, 246, 0.02) 25%,
            rgba(16, 185, 129, 0.02) 75%,
            var(--bg-card) 100%)`,
        borderRadius: 'var(--radius-xl)',
        padding: 'var(--spacing-3xl)',
        textAlign: 'center',
        marginBottom: 'var(--spacing-3xl)',
        backdropFilter: 'blur(4px)',
    }

    ,
    ctaButton: {

        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        backgroundColor: {
            default: 'var(--accent)',
            ':hover': 'var(--accent-hover)',
        }

        ,
        marginTop: 'var(--spacing-xl)',
        color: 'var(--text-on-accent)',
        paddingBlock: 'var(--spacing-md)',
        paddingInline: 'var(--spacing-xl)',
        borderRadius: 'var(--radius-full)',
        textDecoration: 'none',
        fontWeight: 600,
        fontSize: 'var(--font-size-lg)',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-normal)',
        boxShadow: {
            default: '0 4px 12px rgba(0, 0, 0, 0.15)',
            ':hover': '0 6px 20px rgba(0, 0, 0, 0.2)',
        }

        ,
        transform: {
            default: 'none',
            ':hover': 'translateY(-2px)',
        }

        ,
    }

    ,
});